var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28903 11C7.03413 11 5.20618 9.20914 5.20618 7C5.20618 4.79086 7.03413 3 9.28903 3C11.5439 3 13.3719 4.79086 13.3719 7C13.3719 9.20914 11.5439 11 9.28903 11Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4755 10C18.4755 10.5523 18.9232 11 19.4755 11H19.5169C20.0692 11 20.5169 10.5523 20.5169 10V8H22.579C23.1313 8 23.579 7.55228 23.579 7C23.579 6.44772 23.1313 6 22.579 6H20.5169V4C20.5169 3.44772 20.0692 3 19.5169 3H19.4755C18.9232 3 18.4755 3.44772 18.4755 4V6H16.4133C15.861 6 15.4133 6.44772 15.4133 7C15.4133 7.55228 15.861 8 16.4133 8H18.4755V10Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.103326 20.1992C0.498961 15.4265 4.45285 13 9.27207 13C14.1591 13 18.1743 15.2932 18.4734 20.2C18.4853 20.3955 18.4734 21 17.7066 21C13.9243 21 8.3038 21 0.845232 21C0.589247 21 0.0817756 20.4592 0.103326 20.1992Z",
    fill: "#212529"
  })));
}

export default SvgAddUserIcon;